import styles from './CheckboxComponent.module.css'
import Form from 'react-bootstrap/Form';
import '../../projectDetails/custom.css'

const CheckboxComponent = ({checked, onChange, text, id, style, type}) => {

    return (
        <div className={styles.component}> 
        <Form>
            <Form.Check 
                type='checkbox'
                label={text}
                checked={checked}
                onChange={onChange}
                className={type ? 'custom-checkbox-mic' : 'custom-checkbox'}
                id={id}
                style = {style}
            />
        </Form>
        </div>
        
    );

}

export default CheckboxComponent;